'use client'
import React, { useRef, useState } from 'react'
import './style.css'
import Header from '../layout/header'
import { useQuery } from '@apollo/client'
import { GET_MONTH_REPORT } from '../graphql/query'
import Chart from 'react-apexcharts'
import html2pdf from 'html2pdf.js';
import { useReactToPrint } from "react-to-print";

export default function Report() {
    const date = new Date()
    const [type, setType] = useState("")
    const [month, setMonth] = useState(date?.toLocaleString('default', { month: 'short' }))
    const year = date?.getFullYear();
    const [months, setMonths] = useState(`${date?.toLocaleString('default', { month: 'long' })}-${year}`)

    const selectedMonth = monthNames?.findIndex((e) => e === months)
    function getMonthByIndex(index) {
        const adjustedIndex = (index % monthNames.length + monthNames.length) % monthNames.length;
        return monthNames[adjustedIndex];
    }

    const oldMonths = [getMonthByIndex(selectedMonth - 3), getMonthByIndex(selectedMonth - 2), getMonthByIndex(selectedMonth - 1)]

    const { data, loading } = useQuery(GET_MONTH_REPORT, {
        variables: {
            "months": monthNames
        }
    })

    const refs = useRef(null)

    // const onPrint = async () => {
    //     if (refs?.current) {
    //         await html2pdf(refs?.current, { image: { type: 'jpeg', quality: 0.5 }, filename: `Top Level Report.pdf`, jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }, pagebreak: { mode: ['avoid-all', 'css', 'legacy'] } });
    //     }
    // }
    const onPrint = useReactToPrint({ contentRef: refs });

    const getAll = (id, role) => {
        let val = 0
        const datas = data?.getMonthReports?.filter((e) => e?.role === role)
        datas?.forEach((itm) => {
            if (itm?.reports) {
                const vals = JSON.parse(itm?.reports)
                val += vals[id] * 1
            }
        })
        return val
    }

    return (
        <div className='Answer'>
            <Header title={'Overall Report'} month={month} setMonth={setMonth} type={type} setType={setType} btn={<button onClick={() => onPrint()}>Download</button>} />
            <span>
                {loading ?
                    <div className="Loading">
                        Loading...
                    </div>
                    :
                    <div className='Answer_Con'>
                        <div className='Answer_Pyramid_Con'>
                            <div className='Answer_Pyramid'>
                                <div className='Answer_Pyramid_Item'>
                                    0 National<br />CENTER
                                </div>
                                <div className='Answer_Pyramid_Item1'>
                                    {getAll("noCentreNew", "Relational")} CENTER
                                </div>
                                <div className='Answer_Pyramid_Item1'>
                                    0 COMMUNITIES
                                </div>
                                <div className='Answer_Pyramid_Item1'>
                                    {getAll("noNewPartners", "Together")} PARTNER CHURCHES
                                </div>
                                <div className='Answer_Pyramid_Item1'>
                                    {getAll("noRequestReg", "Innovation")} RE TEACHERS
                                </div>
                                <div style={{ border: "none" }} className='Answer_Pyramid_Item1'>
                                    0 CHURCHES
                                </div>
                            </div>
                        </div>
                        <div style={{display:"flex", flexDirection:"column", alignItems:"center"}} ref={refs}>
                            {reportDatas?.filter((e) => type ? e?.id == type : true)?.map((item, index) => {
                                // const getAns = (id, report) => {
                                //     const dat = report ? JSON.parse(report) : null
                                //     return report ? dat[id] : null
                                // }
                                const datas = data?.getMonthReports?.filter((e) => e?.role === item?.id)
                                const target = data?.getTargets?.find((e) => e?.role === item?.id)?.targets ? JSON.parse(data?.getTargets?.find((e) => e?.role === item?.id)?.targets) : null
                                return (
                                    <div className='Answer_Con1' key={index}>
                                        <h2>{item?.id}</h2>
                                        <div className='Report_Graph_Con'>
                                            {item?.sections?.map((itm, ind) => {
                                                return (
                                                    <div key={ind} className='Report_Graph'>
                                                        <p>{itm?.question}</p>
                                                        {itm?.inType === 'textarea' ?
                                                            <>
                                                                <Comments item={itm} datas={datas} />
                                                                <div style={{ height: 10 }} />
                                                            </>
                                                            :
                                                            <Charts item={itm} targets={target} oldMonths={oldMonths} datas={datas} />
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                }
            </span>
        </div>
    )
}

function Comments({ datas, item }) {
    return (
        datas?.map((itm, ind) => {
            const report = itm?.reports ? JSON.parse(itm?.reports) : {}
            return <p key={ind}>{itm?.month}: {report[item?.id] || "--"}</p>
        })
    )
}

const Charts = React.memo(({ datas, oldMonths, item, targets }) => {
    const target = targets ? targets[item?.id] || "" : ""
    var options = {
        chart: {
            legend: {
                show: false
            },
            type: 'bar',
            xaxis: {
                categories: oldMonths
            },
            chart: {
                toolbar: {
                    show: false
                },
                animations:{
                    enabled: false
                }
            },
            stroke: {
                width: 2
            },
            tooltip: {
                custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                    return (
                        `<div class="ToolTip">
                      ${w.globals.seriesNames[seriesIndex]}: ${series[seriesIndex][dataPointIndex]}
                      </div>`
                    )
                }
            },
        },
        series: [{
            name: 'Answer',
            type: 'column',
            data: oldMonths.map((itm) => {
                const data = datas?.find((e) => e?.month === itm)?.reports ? JSON.parse(datas?.find((e) => e?.month === itm)?.reports) : {}
                return data[item?.id] || 0
            })
        },
        {
            name: 'Yearly Target',
            type: 'line',
            data: oldMonths?.map((itm) => target || 0)
        },
        ],
        series1: [{
            name: 'Answer',
            type: 'column',
            data: oldMonths.map((itm) => {
                const data = datas?.find((e) => e?.month === itm)?.reports ? JSON.parse(datas?.find((e) => e?.month === itm)?.reports) : {}
                return data[item?.id] || 0
            })
        }],
    }
    return <Chart options={options.chart} type={'bar'} series={target ? options.series : options?.series1} />
})

const reportDatas = [
    {
        id: "Courageous",
        sections: [
            { id: "noSocialResponse", question: "No. Advocacy social media responses (contrast against target)", type: "number" },
            { id: "noPressEngage", question: "No. Advocacy Press engagements (contrast against target)", type: "number" },
            { id: "noChurchEngage", question: "No. Denominational / church advocacy relationships (contrast against target)", type: "number" },
            { id: "noChurchInvite", question: "No. of Church Invitations", type: "number" },
            { id: "noNewProject", question: "No. New Projects initiated (show last 3 months)", type: "number" },
            { id: "projectComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noYouthEvents", question: "No. Youth events (org wide)", type: "number", auto: true },
            { id: "noYoungReach", question: "No. Young people reached (org wide)", type: "number", auto: true },
            { id: "noYoungOpport", question: "No. Young people given an opportunity to become a follower of Jesus (org wide)", type: "number", auto: true },
            { id: "noYoungFollow", question: "No. Young people made a decision to follow Jesus (org wide)", type: "number", auto: true },
            { id: "noYouthLeader", question: "No. Youth Leader events (org wide)", type: "number", auto: true },
            { id: "noYouthLeaderEngage", question: "No. Youth Leaders engaged with (org wide)", type: "number", auto: true },
            { id: "youthComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noJonJacketHit", question: "No. Jon Jackal music plays", type: "number" },
            { id: "noJonJacketSale", question: "No. Jon Jackal Merch sales (units) ", type: "number" },
            { id: "noJonJacketInter", question: "No. of Jon Jackal meaningful interactions", type: "number" },
            { id: "noJonJacketViews", question: "No. of Jon Jackal views", type: "number" },
            { id: "noJonJacketSchool", question: "No. of Schools Visited (Jon Jackal)", type: "number" },
            { id: "jonComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noUndergroundViews", question: "No. of Underground views", type: "number" },
            { id: "undergroundComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noArticles", question: "No. of articles written and published in external publications (org wide)", type: "number", auto: true },
            { id: "noPodcasts", question: "No. of podcasts recorded and uploaded (org wide)", type: "number", auto: true },
            { id: "mediaComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noNewPartner", question: "No. New partnerships (org wide)", type: "number" },
            { id: "noExternal", question: "No. External appointments", type: "number" },
            { id: "partnerComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noStrategic", question: "No. of strategic bodies (contrast against target)", type: "number" },
            { id: "noStrategicComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noSpeakEvent", question: "No of speaking at events", type: "number" },
            { id: "noSundaySpoke", question: "No. of Sunday Services spoken at (inc. home church)", type: "number" },
            { id: "speakEventComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "manageAccounts", question: "Management accounts for Courageous Surplus/Deficit £", type: "number" },
            { id: "accountComment", question: "Any Comments", type: "", inType: 'textarea' },
        ]
    },
    {
        id: "Helpful",
        sections: [
            { id: "incomeLast", question: "Income (last complete month) (The income total reflects the position at the close of the latest management accounts)", type: "number" },
            { id: "incomeBudget", question: "Income against budget", type: "number" },
            // { id: "incomeForecast", question: "Income against forecast", type: "number" },
            { id: "incomeComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "expenseLast", question: "Expense (last complete month) (The expenditure total reflects the position at the close of the latest management accounts)", type: "number" },
            { id: "expenseBudget", question: "Expense against budget", type: "number" },
            { id: "expenseComment", question: "Any Comments", type: "", inType: 'textarea' },
            // { id: "expenseForecast", question: "Expense against forecast", type: "number" },
            { id: "generalCash", question: "General & Designated Cash £ (Month end position)", type: "number" },
            { id: "generalRestrict", question: "Restricted Cash £ (Month end position)", type: "number" },
            { id: "generalComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noCourStaffSick", question: "Number of staff sick (Courageous)", type: "number" },
            { id: "noCourSickDays", question: "Number of sick days taken (Courageous)", type: "number" },
            { id: "noCourStaffAL", question: "Number of staff on AL (Courageous)", type: "number" },
            { id: "noCourALDays", question: "Number of AL days taken (Courageous)", type: "number" },
            { id: "staffCourComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noHelpStaffSick", question: "Number of staff sick (Helpful)", type: "number" },
            { id: "noHelpSickDays", question: "Number of sick days taken (Helpful)", type: "number" },
            { id: "noHelpStaffAL", question: "Number of staff on AL (Helpful)", type: "number" },
            { id: "noHelpALDays", question: "Number of AL days taken (Helpful)", type: "number" },
            { id: "staffHelpComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noRelStaffSick", question: "Number of staff sick (Relational)", type: "number" },
            { id: "noRelSickDays", question: "Number of sick days taken (Relational)", type: "number" },
            { id: "noRelStaffAL", question: "Number of staff on AL (Relational)", type: "number" },
            { id: "noRelALDays", question: "Number of AL days taken (Relational)", type: "number" },
            { id: "staffRelComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noInovStaffSick", question: "Number of staff sick (Innovation)", type: "number" },
            { id: "noInovSickDays", question: "Number of sick days taken (Innovation)", type: "number" },
            { id: "noInovStaffAL", question: "Number of staff on AL (Innovation)", type: "number" },
            { id: "noInovALDays", question: "Number of AL days taken (Innovation)", type: "number" },
            { id: "staffInovComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noSprStaffSick", question: "Number of staff sick (Spiritual)", type: "number" },
            { id: "noSprSickDays", question: "Number of sick days taken (Spiritual)", type: "number" },
            { id: "noSprStaffAL", question: "Number of staff on AL (Spiritual)", type: "number" },
            { id: "noSprALDays", question: "Number of AL days taken (Spiritual)", type: "number" },
            { id: "staffSprComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noTogStaffSick", question: "Number of staff sick (Together)", type: "number" },
            { id: "noTogSickDays", question: "Number of sick days taken (Together)", type: "number" },
            { id: "noTogStaffAL", question: "Number of staff on AL (Together)", type: "number" },
            { id: "noTogALDays", question: "Number of AL days taken (Together)", type: "number" },
            { id: "staffTogComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noResignation", question: "No. Resignations", type: "number" },
            { id: "noNewStarter", question: "No. New starters", type: "number" },
            { id: "noRecruit", question: "No. Recruiting for posts", type: "number" },
            { id: "regComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noTrainEvents", question: "No. Training events (contrast against target)", type: "number" },
            { id: "trainingComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noOnlineSales", question: "No. Online shop orders", type: "number" },
            { id: "noProductOnlineSales", question: "No. Of products sold from online shop orders", type: "number" },
            { id: "salesStands", question: "No. of products sold from stands", type: "number" }, //New
            { id: "salesCentres", question: "No. of products sold to centres", type: "number" }, //New
            { id: "salesComment", question: "Any Comments", type: "", inType: 'textarea' },
            // { id: "noYouthEvents", question: "No. Youth events (org wide)", type: "number" },
            // { id: "noYoungReach", question: "No. Young people reached (org wide)", type: "number" },
            // { id: "noYoungOpport", question: "No. Young people given an opportunity to become a follower of Jesus (org wide)", type: "number" },
            // { id: "noYoungFollow", question: "No. Young people made a decision to follow Jesus (org wide)", type: "number" },
            { id: "noYouthLeader", question: "No. Youth Leader events (org wide)", type: "number" },
            { id: "noYouthLeaderEngage", question: "No. Youth Leaders engaged with (org wide)", type: "number" },
            { id: "noArticles", question: "No. of articles written and published in external publications (org wide)", type: "number" },
            { id: "noPodcasts", question: "No. of podcasts recorded and uploaded (org wide)", type: "number" },
            { id: "mediaComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noSpeakEvent", question: "No of speaking at events (org wide)", type: "number" },
            { id: "noSundaySpoke", question: "No. of Sunday Services spoken at (inc. home church)", type: "number" },
            { id: "speakEventComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "manageAccounts", question: "Management accounts for Helpful surplus/deficit £ (This total reflects the position at the close of the latest management accounts)", type: "number" },
            { id: "accountComment", question: "Any Comments", type: "", inType: 'textarea' },
        ]
    },
    {
        id: "Relational",
        sections: [
            { id: "noCentreNew", question: "No. new centres (contrast against target)", type: "number" },
            { id: "noNewCentre", question: "No. New Centre enquiries", type: "number" },
            { id: "noCentreContact", question: "No. Centre contacts (contrast against target)", type: "number" },
            { id: "noCentreVisits", question: "No. Centre visits (contrast against target)", type: "number" },
            { id: "noCentreTrustee", question: "No. Centre Trustee contacts/visits (contrast against target)", type: "number" },
            { id: "noCentreInterest", question: "No. of interested centres", type: "number" },
            { id: "centreComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noChurchEnquiry", question: "No. Church enquiries", type: "number" },
            { id: "noChurchVisit", question: "No. Church Consultations (contrast against target)", type: "number" },
            { id: "noChurchFollowUp", question: "No. Church follow up meetings (contrast against target)", type: "number" },
            { id: "churchComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noWhyAppointment", question: "No. of Why Pack Opportunities/Appointments", type: "number" },
            { id: "noWhyPhone", question: "No. Of Why Pack phone calls", type: "number" },
            { id: "noPluseEnquiry", question: "No. Pulse enquiries", type: "number" },
            { id: "noPluseGather", question: "No. Pulse Gatherings Launched - Total (contrast against target)", type: "number" },
            { id: "noPluseLearn", question: "No. Pulse Learning Communities - Total (contrast against target)", type: "number" },
            // { id: "noColdCall", question: "No. Cold call follow ups", type: "number" },
            { id: "noPulseGatherCall", question: "No. of support calls to Pulse Gatherings", type: "number" },
            { id: "noPulseGatherVisit", question: "No. of in person visits to Pulse Gatherings", type: "number" },
            { id: "noPluseChurch", question: "No. of new churches engaged in Pulse", type: "number" },
            { id: "pluseComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noUrbanEvent", question: "No. Urban Outreach events (contrast against target)", type: "number" },
            { id: "noUrbanYouthEvent", question: "No. Urban youth leader events (contrast against target)", type: "number" },
            { id: "urbanComment", question: "Any Comments", type: "", inType: 'textarea' },
            // { id: "noYouthEvents", question: "No. Youth events (org wide)", type: "number" },
            // { id: "noYoungReach", question: "No. Young people reached (org wide)", type: "number" },
            // { id: "noYoungOpport", question: "No. Young people given an opportunity to become a follower of Jesus (org wide)", type: "number" },
            // { id: "noYoungFollow", question: "No. Young people made a decision to follow Jesus (org wide)", type: "number" },
            { id: "noYouthLeader", question: "No. Youth Leader events (org wide)", type: "number" },
            { id: "noYouthLeaderEngage", question: "No. Youth Leaders engaged with (org wide)", type: "number" },
            { id: "youthComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noArticles", question: "No. of articles written and published in external publications (org wide)", type: "number" },
            { id: "noPodcasts", question: "No. of podcasts recorded and uploaded (org wide)", type: "number" },
            { id: "mediaComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noSpeakEvent", question: "No of speaking at events (org wide)", type: "number" },
            { id: "noSundaySpoke", question: "No. of Sunday Services spoken at (inc. home church)", type: "number" },
            { id: "speakEventComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "manageAccounts", question: "Management accounts for Relational Surplus/Deficit £", type: "number" },
            { id: "accountComment", question: "Any Comments", type: "", inType: 'textarea' },
        ]
    },
    {
        id: "Innovation",
        sections: [
            { id: "noProjectDesign", question: "No. Projects assigned Design (show last 3 months)", type: "number" },
            { id: "noCompleteDesign", question: "No. Projects completed Design (show last 3 months)", type: "number" },
            { id: "noProjectVideo", question: "No. Projects assigned Video (show last 3 months)", type: "number" },
            { id: "noCompleteVideo", question: "No. Projects completed Video (show last 3 months)", type: "number" },
            { id: "projectComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noSchoolContent", question: "No. School lessons/Assembly content produced (contrast against target)", type: "number" },
            { id: "noCommunity", question: "No. Community content produced (contrast against target)", type: "number" },
            { id: "noChurchContent", question: "No. Church content produced (contrast against target)", type: "number" },
            { id: "noUniqueProject", question: "No. Stand alone / Unique projects produced (show last 3 months)", type: "number" },
            { id: "contentComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noRequestHit", question: "ReQuest hits (unique users) (show last 3 months)", type: "number" },
            { id: "noRequestReg", question: "ReQuest no. Registered teachers (contrast against target) ", type: "number" },
            { id: "requestComment", question: "Any Comments", type: "", inType: 'textarea' },
            // { id: "noYouthEvents", question: "No. Youth events (org wide)", type: "number" },
            // { id: "noYoungReach", question: "No. Young people reached (org wide)", type: "number" },
            // { id: "noYoungOpport", question: "No. Young people given an opportunity to become a follower of Jesus (org wide)", type: "number" },
            // { id: "noYoungFollow", question: "No. Young people made a decision to follow Jesus (org wide)", type: "number" },
            { id: "noTotalRegister", question: "No. Total registered MyLife licences", type: "number" },
            { id: "noCourseSale", question: "No. MyLife licenses (contrast against target)", type: "number" },
            // { id: "noCourseSaleTarget", question: "Target", type: "number" },
            { id: "noBooksSale", question: "No. of any MyLife printed material sold (contrast against target).", type: "number" },
            // { id: "noBooksSaleTarget", question: "Target", type: "number" },
            { id: "noAccredEntries", question: "No. MyLife accreditation entries", type: "number" },
            { id: "noAppointment", question: "No. of new MyLife opportunities/appointments this month (contrast against target)", type: "number" },
            { id: "noTrainSession", question: "No. of training sessions held", type: "number" },
            { id: "noPeopleTrain", question: "No. of people trained", type: "number" },
            // { id: "noAppointmentTarget", question: "Target", type: "number" },
            { id: "noProspects", question: "No. of MyLife prospects", type: "number" },

            { id: "noYouthLeader", question: "No. Youth Leader events (org wide)", type: "number" },
            { id: "noYouthLeaderEngage", question: "No. Youth Leaders engaged with (org wide)", type: "number" },
            { id: "noArticles", question: "No. of articles written and published in external publications (org wide)", type: "number" },
            { id: "noPodcasts", question: "No. of podcasts recorded and uploaded (org wide)", type: "number" },
            { id: "noTrainVideo", question: "No. Training Wall videos ", type: "number" },
            { id: "mediaComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noSpeakEvent", question: "No of speaking at events (org wide)", type: "number" },
            { id: "noSundaySpoke", question: "No. of Sunday Services spoken at (inc. home church)", type: "number" },
            { id: "speakEventComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "manageAccounts", question: "Management accounts for Innovation Surplus/Deficit £", type: "number" },
            { id: "accountComment", question: "Any Comments", type: "", inType: 'textarea' },
        ]

    },
    {
        id: "Spiritual",
        sections: [
            { id: "noPrayerPartner", question: "Total No. of Prayer Partners (contrast against target)", type: "number" },
            { id: "noNewPrayerPartner", question: "No. of new prayer partners", type: "number" },
            { id: "noPrayerInitiative", question: "No. Prayer initiatives (org wide)", type: "number" },
            { id: "prayerComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noCentreEngage", question: "No. Centres engaged in research", type: "number" },
            { id: "researchProcess", question: "Centre research process (begun for the month)", type: "number" },
            { id: "researchLaunch", question: "Centre research launched (complete that month)", type: "number" },
            { id: "centreComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "interResearchProcess", question: "International research process (begun for the month)", type: "number" },
            { id: "interResearchLaunch", question: "International research launched (complete for the month)", type: "number" },
            { id: "interContact", question: "International contact support for nations (nations given any kind of assistance)", type: "number" },
            { id: "resourceAvail", question: "Resources made available to nations (for the month)", type: "number" },
            { id: "resourceEnquiry", question: "Resources enquiry for International (for the month)", type: "number" },
            { id: "resourceInterProcess", question: "Resources for International process (begun for the month)", type: "number" },
            { id: "resourceInterLaunch", question: "Resources for International launched (complete for the month)", type: "number" },
            { id: "researchComment", question: "Any Comments", type: "", inType: 'textarea' },
            // { id: "noYouthEvents", question: "No. Youth events (org wide)", type: "number" },
            // { id: "noYoungReach", question: "No. Young people reached (org wide)", type: "number" },
            // { id: "noYoungOpport", question: "No. Young people given an opportunity to become a follower of Jesus (org wide)", type: "number" },
            // { id: "noYoungFollow", question: "No. Young people made a decision to follow Jesus (org wide)", type: "number" },
            { id: "noYouthLeader", question: "No. Youth Leader events (org wide)", type: "number" },
            { id: "noYouthLeaderEngage", question: "No. Youth Leaders engaged with (org wide)", type: "number" },
            { id: "noArticles", question: "No. of articles written and published in external publications (org wide)", type: "number" },
            { id: "noPodcasts", question: "No. of podcasts recorded and uploaded (org wide)", type: "number" },
            { id: "mediaComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noSpeakEvent", question: "No of speaking at events (org wide)", type: "number" },
            { id: "noSundaySpoke", question: "No. of Sunday Services spoken at (inc. home church)", type: "number" },
            { id: "speakEventComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "manageAccounts", question: "Management accounts for Spiritual Surplus/Deficit £", type: "number" },
            { id: "accountComment", question: "Any Comments", type: "", inType: 'textarea' },
        ]
    },
    {
        id: "Together",
        sections: [
            { id: "noGrantWritten", question: "No. Grants written & submitted (contrast against target)", type: "number" },
            { id: "noGrantSubmit", question: "No. Grant reports submitted", type: "number" },
            { id: "noGrantSuccess", question: "No. Grants Successful", type: "number" },
            { id: "noGrantReceived", question: "No. Grants actually received", type: "number" },
            { id: "grandComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noTFTDsub", question: "No. TFTD subscribers (contrast against target)", type: "number" },
            { id: "noTFTDopen", question: "No. TFTD open rate (show last 3 months)", type: "number" },
            { id: "TFTDComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noPartners", question: "No. Financial Partners (show last 3 months)", type: "number" },
            { id: "noNewPartners", question: "No. of New Financial Partners (contrast against target)", type: "number" },
            { id: "noNewSupporter", question: "No. New personal supporters (contrast against target)", type: "number" },
            { id: "partnerComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noEvents", question: "No. Events (stands/fundraisers/church invitations) (show last 3 months)", type: "number" },
            { id: "noDonors", question: "No. Major donors contacted (contrast against target)", type: "number" },
            { id: "noDonorsVisit", question: "No. Major donors visited (contrast against target)", type: "number" },
            { id: "noDonorsGiven", question: "No. Major donors given (contrast against target)", type: "number" },
            { id: "donorComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noPaySubscribe", question: "Total No. of paying subscribers", type: "number" },
            { id: "noPaySubscribeLeft", question: "Total No. of subscribers who have left this month", type: "number" },
            { id: "noSubscriber", question: "Total No. of Subscribers (free trial and paying users) (show last 3 months)", type: "number" },
            { id: "noSubscriberFree", question: "No. of Subscribers on a free trial", type: "number" },
            { id: "noNewSubscriber", question: "No. of New paying subscribers this month (contrast against target)", type: "number" },
            { id: "subscriberComment", question: "Any Comments", type: "", inType: 'textarea' },
            // { id: "noTotalRegister", question: "No. Total registered MyLife licences", type: "number" },
            // { id: "noCourseSale", question: "No. MyLife licenses (contrast against target)", type: "number" },
            // { id: "noBooksSale", question: "No. of any MyLife printed material sold (contrast against target).", type: "number" },
            // { id: "noAccredEntries", question: "No. MyLife accreditation entries", type: "number" },
            // { id: "noAppointment", question: "No. of new MyLife opportunities/appointments this month (contrast against target)", type: "number" },
            // { id: "noTrainSession", question: "No. of training sessions held", type: "number" },
            // { id: "noPeopleTrain", question: "No. of people trained", type: "number" },
            { id: "noSeriesSent", question: "No. of Why Packs sent out", type: "number" },
            { id: "noSocialPost", question: "No. Social media posts (contrast against target)", type: "number" },
            { id: "postComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noPaidAd", question: "No. Paid advertising adverts (contrast against target)", type: "number" },
            { id: "adsComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "noWebsiteHit", question: "Website hits (unique users) (show last 3 months)", type: "number" },
            { id: "noWebsiteClick", question: "Website multiple clicks (show last 3 months)", type: "number" },
            { id: "websiteComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "stackRate", question: "Stack open rate", type: "number" },
            { id: "stackComment", question: "Any Comments", type: "", inType: 'textarea' },
            // { id: "noYouthEvents", question: "No. Youth events (org wide)", type: "number" },
            // { id: "noYoungReach", question: "No. Young people reached (org wide)", type: "number" },
            // { id: "noYoungOpport", question: "No. Young people given an opportunity to become a follower of Jesus (org wide)", type: "number" },
            // { id: "noYoungFollow", question: "No. Young people made a decision to follow Jesus (org wide)", type: "number" }, 
            { id: "noYouthLeader", question: "No. Youth Leader events (org wide)", type: "number" },
            { id: "noYouthLeaderEngage", question: "No. Youth Leaders engaged with (org wide)", type: "number" },
            { id: "noArticles", question: "No. of articles written and published in external publications (org wide)", type: "number" },
            { id: "noPodcasts", question: "No. of podcasts recorded and uploaded (org wide)", type: "number" },
            { id: "noSpeakEvent", question: "No of speaking at events (org wide)", type: "number" },
            { id: "noSundaySpoke", question: "No. of Sunday Services spoken at (inc. home church)", type: "number" },
            { id: "speakEventComment", question: "Any Comments", type: "", inType: 'textarea' },
            { id: "manageAccounts", question: "Management accounts for Together Surplus/Deficit £", type: "number" },
            { id: "accountComment", question: "Any Comments", type: "", inType: 'textarea' },
        ]
    },
]

// const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const monthNames = ['September-2024', 'October-2024', 'November-2024', 'December-2024', 'January-2025', 'February-2025', 'March-2025', 'April-2025', 'May-2025', 'June-2025', 'July-2025', 'August-2025', 'September-2025', 'October-2025', 'November-2025', 'December-2025', 'January-2026', 'February-2026', 'March-2026', 'April-2026', 'May-2026', 'June-2026', 'July-2026', 'August-2026'];